import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  NoOffersSection,
  NoOffersWrapper,
  NoOffersTitle,
  Cta,
  Ctas,
  NoOfferText,
} from './NoOffers.styles';

const NoOffers: React.FC = () => {
  const { t } = useTranslation();
  return (
    <NoOffersSection>
      <NoOffersWrapper>
        <NoOffersTitle>{t('promo.noOffers.title')}</NoOffersTitle>
        <NoOfferText>{t('promo.noOffers.description')}</NoOfferText>
        <Ctas>
          <Cta href="https://www.audiusa.com/en/inventory/">
            {t('promo.noOffers.browseInventory')}
          </Cta>
          <Cta href="#contact_general">{t('promo.noOffers.contactDealer')}</Cta>
        </Ctas>
      </NoOffersWrapper>
    </NoOffersSection>
  );
};

export default NoOffers;
